import apollo from '@/graphql'

import StoresByLocationQuery from '@/graphql/pricing/StoresByLocationQuery.gql'

// initial state
const state = {
  storeSearchResults: [],
  isStoreSearchResultsLoading: false,
}

// getters
const getters = {
  storeSearchResults: st => st.storeSearchResults,
  isStoreSearchResultsLoading: st => st.isStoreSearchResultsLoading,
}

const mutations = {
  setStoreSearchResults(st, stores) {
    state.storeSearchResults = stores
  },
  setStoreSearchLoading(st, loading) {
    state.isStoreSearchResultsLoading = loading
  },
}

// actions
const actions = {
  async searchStores({ commit }, { lat, lng, radius }) {
    commit('setStoreSearchLoading', true)
    const { data: { storesByLocation } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: StoresByLocationQuery,
        variables: {
          lat,
          lng,
          radius,
        },
      })

    commit('setStoreSearchResults', storesByLocation)
    commit('setStoreSearchLoading', false)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/pricing/StoreSearch.js